import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import Styles from "../Styles.js";
import { Affiliations } from "../parts/affiliations.js";
import { DataClassifications } from "../parts/dataClassifications.js";
import { Billing } from "../parts/billing.js";

const required = value => (value ? undefined : "Required");

class CreateProjectContainer extends Component {
  constructor(props) {
    super(props);

    this.onAddMember = this.onAddMember.bind(this);
  }

  onSubmit = (values) => {
    console.log(values);
  };

  onAddMember = (values) => {
    // To Do: check person with GET /v1/person
    let members = values.members || [];
    members.push(values.new_member);
    values.new_member = null;
    values.members = members;
  }

  render() {
    return (
      <div style={{padding: "50px"}}>
        <Styles>
          <h1>Create New Research Project</h1>
          <div>
            <Form
              onSubmit={this.onSubmit}
              render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit}>
                  <h2>Project Information</h2>
                  <Affiliations/>
                  <Field name="projectTitle" validate={required}>
                    {({ input, meta }) => (
                      <div>
                        <label>
                          <h3>Project Title</h3>
                        </label>
                        <input {...input} type="text" placeholder="Project Title" />
                        {meta.error && meta.touched && <span>{meta.error}</span>}
                      </div>
                    )}
                  </Field>
                  <Field name="description" validate={required}>
                    {({ input, meta }) => (
                      <div>
                        <label>
                          <h3>Description</h3>
                        </label>
                        <input {...input} type="textarea" placeholder="Description" />
                        {meta.error && meta.touched && <span>{meta.error}</span>}
                      </div>
                    )}
                  </Field>
                  <DataClassifications/>
                  <Field name="TCP">
                    {({ input, meta }) => (
                      <div>
                        <label>
                          <h3>Technology Control Plan (TCP) Number</h3>
                        </label>
                        <input {...input} type="text" />
                        {meta.error && meta.touched && <span>{meta.error}</span>}
                      </div>
                    )}
                  </Field>
                  <Billing/>

                  <div className="buttons">
                    <button type="submit" disabled={submitting}>
                      Submit
                    </button>
                    <button
                      type="button"
                      onClick={reset}
                      disabled={submitting || pristine}
                    >
                      Reset
                    </button>
                  </div>
                  <pre>{JSON.stringify(values, 0, 2)}</pre>
                </form>
              )} />
            </div>
        </Styles>
      </div>
    );
  }
}

export default CreateProjectContainer;
